import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import React, { FC } from "react";
import { css } from "styled-components";

/**
 * ChangeLog:
 * 20230412: DLD: Initial creation. No base widget.
 * - Created to add an accordion around all filter elements on the PLP.
 * - Desired filter widgets must be manually added to the zone in the admin CMS.
 */
const enum fields {
    expandedByDefault = "expandedByDefault",
    accordionTitle = "accordionTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandedByDefault]: boolean;
        [fields.accordionTitle]: string;
    };
}

type Props = OwnProps;

export interface ProductListMainFiltersAccordionStyles {
    accordion?: AccordionPresentationProps;
}

export const productListMainFiltersAccordionStyles: ProductListMainFiltersAccordionStyles = {
    accordion: {
        css: css`
            padding-top: 20px;
            padding-bottom: 20px;
        `,
    },
};

const styles = productListMainFiltersAccordionStyles;

const ProductListMainFiltersAccordion: FC<Props> = ({ id, fields }) => {
    const { expandedByDefault, accordionTitle } = fields;
    return (
        <Accordion headingLevel={2} {...styles.accordion}>
            <ManagedAccordionSection initialExpanded={expandedByDefault} title={accordionTitle}>
                <Zone contentId={id} zoneName="Content" />
            </ManagedAccordionSection>
        </Accordion>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListMainFiltersAccordion,
    definition: {
        group: "Product List",
        displayName: "Main Filters Accordion",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.accordionTitle,
                displayName: "Accordion title",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "Filters",
                isRequired: true,
                sortOrder: 1,
            },
            {
                name: fields.expandedByDefault,
                displayName: "Accordion is expanded by default",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                sortOrder: 2,
            },
        ],
    },
};

export default widgetModule;
